export const GLOBAL = {
    WHATSAPP_BASE: 'https://wa.me/',
};
